import React, { Component } from "react";
import "./facturacion.css";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import moment from 'moment'
import Modal from 'react-modal'
import Select from 'react-select'

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };


class FacturacionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // [1 => Ingresa el código unico]
      // [2 => Ingresa los datos de facturación]
      // [3 => Notificación de facturación exitosa]
      step: 1, 
      codigoUnico: '',
      arrItems: [],

      razon_social: '',
      rfc: '',
      telefono: '',
      email: '',
      direccion_calle: '',
      direccion_colonia: '',
      direccion_noext: '',
      direccion_noint: '',
      direccion_cp: '',
      direccion_ciudad: '',
      direccion_estado: '',
      id: 0,

      arrUpload: []

    }
    this.onFileChange = this.onFileChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
  }

  render() {
    const { arrItems, arrUpload, } = this.state
    const disponible = true;

    if(!disponible) return (<Container><Row><Col xs={"12"}><p style={{alignSelf:'center',fontSize:'1.8rem',marginTop:'50px'}}>El servicio de facturación en línea no se encuentra disponible en este momento, por favor visita tu sucursal más cercana</p></Col></Row></Container>);

    let t = arrUpload[0],
    e = 0

    return (
      <div className="facturacionPage__wrapper" >
        <div style={{ background: '#b71540', height: 190, overflow: 'hidden', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, }} >
          <Container>
            <Row className={'facturacionHeader__row'}>
              <Col xs={'2'}>
                <img alt={"img"} src={ 'img/hgapp/logohg.png' } className={'facturacionHeader__profile'} />
              </Col>
              <Col className={'facturacionHeader__description'}>
                <p>Facturación en línea<br /><span>Carnicerías Hermanos González</span></p>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className={'facturacionBody'}>
          
          <Row>
            <Col xs={'7'} className={'facturacionPage__panel'}>

              <p>Introduce el código unico del ticket a facturar</p>
              <input
                value={this.state.codigoUnico}
                onChange={(event) => { this.setState({ codigoUnico: event.target.value }) }}
                type={"text"}
                placeholder="Ingresa el código aquí..."
                ref={(input) => { this.inputSearchCodigoUnico = input; }}
              />
              <button
                className={'btn btn-primary'}
                onClick={ () => { this.onVerificaCodigoUnico() } }
              >Buscar</button>
            </Col>
            <Col className={'facturacionPage__listado z-depth-1'}>
              { arrItems.length === 0 ? <p style={{ textAlign: 'center', }}>Ingresa el primer producto</p> : null }
              { arrItems.length > 0 ? (
                <>
                  <p style={{ textAlign: 'center', }}>Listado de tickets</p>
                  <Row>
                    <Col xs={'4'}>Código</Col>
                    <Col xs={'4'}>Fecha</Col>
                    <Col>Productos</Col>
                    <Col>Total</Col>
                  </Row>
                  {
                    arrItems.map((t,e) => (
                      <Row>
                        <Col xs={'4'}>
                          <p>{t.codigo}</p>
                        </Col>
                        <Col xs={'4'}>
                          <p>{moment(t.created_at).format('DD/MM/YYYY HH:mm:ss')}</p>
                        </Col>
                        <Col>
                          <p style={{ textAlign: 'center', }}>{this.number_format(t.arr.listado.length,0)}</p>
                        </Col>
                        <Col>
                          <p style={{ textAlign: 'center', }}>${this.number_format(t.arr.total,2)} <span onClick={() => { this.deleteItemProduct(e) }} style={{ cursor: 'pointer', color: 'red', fontWeight: '800', position: 'absolute', right: 0, top: '5px', zIndex: 1, }}>x</span></p>
                        </Col>
                      </Row>
                    ))
                  }

                  <button
                    className={'btn btn-primary'}
                    onClick={ () => { this.setState({isOpenDatosFiscales: true,}) }}
                  >Realizar factura</button>

                </>
              ) : null }
            </Col>
          </Row>

        </Container>


        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenDatosFiscales}
          onRequestClose={() => { this.setState({isOpenDatosFiscales: false}) }}
          style={customStyles}
          contentLabel=""
          >
          <div className="modalBody__operador">
            <Row className="modalBody__corte"> 
              <Col>
                <h4>Ingresa los datos solicitados</h4>
                <Select
                  onChange={(item) => { this.setState({ id: item.id }) }}
                  placeholder={'Tipo de persona'}
                  options={[
                    { id: 1, label: 'Persona física', value: 'Persona física' },
                    { id: 2, label: 'Persona moral', value: 'Persona moral' },
                    ]}
                  styles={customStylesOption}
                />

                <Row>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Razón social" onChange={ (event) => { this.setState({ razon_social: event.target.value, })} } /></Col>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="RFC" onChange={ (event) => { this.setState({ rfc: event.target.value, })} } /></Col>
                </Row>
                <Row>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Teléfono" onChange={ (event) => { this.setState({ telefono: event.target.value, })} } /></Col>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Correo electrónico" onChange={ (event) => { this.setState({ email: event.target.value, })} } /></Col>
                </Row>
                <Row>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Calle" onChange={ (event) => { this.setState({ direccion_calle: event.target.value, })} } /></Col>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Colonia" onChange={ (event) => { this.setState({ direccion_colonia: event.target.value, })} } /></Col>
                </Row>
                <Row>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Nº Exterior" onChange={ (event) => { this.setState({ direccion_noext: event.target.value, })} } /></Col>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Nº Interior" onChange={ (event) => { this.setState({ direccion_noint: event.target.value, })} } /></Col>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Código postal" onChange={ (event) => { this.setState({ direccion_cp: event.target.value, })} } /></Col>
                </Row>
                <Row>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Ciudad" onChange={ (event) => { this.setState({ direccion_ciudad: event.target.value, })} } /></Col>
                  <Col><input style={{ marginTop: 0 }} type="text" placeholder="Estado" onChange={ (event) => { this.setState({ direccion_estado: event.target.value, })} } /></Col>
                </Row>

                <hr />

                <p>Para realizar el timbrado de tu factura es necesario que subas la <b>constancia de situación fiscal</b> y aceptes los <b>términos de privacidad y uso</b></p>
                <form>

                {
                  arrUpload.length > 0 && arrUpload.map((t,e) => (
                    <div key={`div_upload_${e}`}>
                      <p>{t.name}</p>
                      <p style={{ fontSize: '.7rem', fontStyle: 'italic', }}>Pulsa para subir un documento</p>
                      <label className="form-group" htmlFor={`upload-file-${e}`}>
                        <p htmlFor={`upload-file-${e}`} style={{ fontSize: '1rem', color: '#111', cursor: 'pointer', }}>Haz click aquí para subir un archivo</p>
                        <input style={{ display: 'none' }} id={`upload-file-${e}`} type="file" onChange={(file) => this.onFileChange(t, e, file)} />
                      </label>
                    </div>
                  ))
                }
                {
                  arrUpload.length == 0 ?
                  <>
                    <p style={{ fontSize: '.7rem', fontStyle: 'italic', }}>Pulsa para subir un documento</p>
                    <label className="form-group" htmlFor={`upload-file-${e}`}>
                      <p htmlFor={`upload-file-${e}`} style={{ fontSize: '1rem', color: '#111', cursor: 'pointer', }}>Haz click aquí para subir un archivo</p>
                      <input style={{ display: 'none' }} id={`upload-file-${e}`} type="file" onChange={(file) => this.onFileChange(t, e, file)} />
                    </label>
                  </> : null
                }
                </form>

                <hr />

                <p
                  style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                  onClick={ () => { this.onRegisterFacturacion() }} className="regVentaPage__title"
                >Registrar</p>

              </Col>
            </Row>
          </div>
        </Modal>

      </div>
    )
  }

  onSubmit() {

  }

  onFileChange(item, index, file) {
    let { arrUpload, } = this.state

    for(var a in file.target.files) {
      if(typeof file.target.files[a] === 'object') {
        arrUpload.push(file.target.files[a])
      }

      if(a == (file.target.files.length - 1)) {
        this.setState({ arrUpload, })
      }
    }
  }

  onFileChangeRemove(index, indexFile) {
    let { arrUpload, } = this.state

    let newArr = []
    for(var a in arrUpload) {
      if(a != indexFile) {
        newArr.push(arrUpload[a])
      }

      if(a == (arrUpload.length - 1)) {
        arrUpload = newArr
        this.setState({ arrUpload, })
      }
    }
  }

  deleteItemProduct(e) {
    let { arrItems, } = this.state
    const arr = arrItems.filter(function(item, index) { return index !== e })
    this.setState({ arrItems: arr, })
  }

  onRegisterFacturacion() {
    const { arrUpload, razon_social, rfc, telefono, email, direccion_calle, direccion_colonia, direccion_noext, direccion_noint, direccion_cp, direccion_ciudad, direccion_estado, id } = this.state
    if(id === 0) {
      alert('Por favor elige el tipo de persona.')
      return false
    }
  
    if(razon_social.trim() === '' || rfc.trim() === '' || telefono.trim() === '') {
      alert('Por favor ingresa los datos, "Razón social", "RFC", "Teléfono".')
      return false
    }

    if(arrUpload.length === 0) {
      alert('Por favor, es necesario que subas la constancia de situación fiscal de tu negocio.')
      return false
    }

    fetch(this.getURLByOPT('setRegisterFactura'), this.headersPOST({...this.state}))
    .then(response => response.json())
    .then((response) => {
      //Aquí
      alert('Tu solicitud de factura fue realizada con éxito.\nRecibirás a tu correo electrónico la factura en breve.')
      window.location.reload()
    }).catch(() => {
      alert('Error, no pudimos procesar tu solicitud. Verifica tu conexión a internet.')
    })


  }

  onVerificaCodigoUnico() {
    const { codigoUnico } = this.state

    if( codigoUnico.trim() === '' ) {
      alert('Por favor, introduce un código válido.')
      return false
    }

    //Petición al servidor
    const data = { codigoUnico }
    fetch(this.getURLByOPT('getCodeUniqueFact'), this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      if(response.status === 0) {
        alert(response.motivo)
      } else if(response.status === 1) {
        //Agregamos el item
        let flagCanAdd = true

        if(this.state.arrItems.length === 0) {
          this.setState({
            arrItems: [...this.state.arrItems, { codigo: codigoUnico, id_pago: response.id_pago, created_at: response.created_at, arr: response.arr, }],
            codigoUnico: '',
          })
          this.inputSearchCodigoUnico.focus(); 
        } else {
          for(var a in this.state.arrItems) {
            if( this.state.arrItems[a].id_pago == response.id_pago ) {
              flagCanAdd = false
            }

            if( a == (this.state.arrItems.length - 1) ) {
              if(flagCanAdd) {
                this.setState({
                  arrItems: [...this.state.arrItems, { codigo: codigoUnico, id_pago: response.id_pago, created_at: response.created_at, arr: response.arr, }],
                  codigoUnico: '',
                })
                this.inputSearchCodigoUnico.focus(); 
              } else {
                alert(`El código "${codigoUnico}", ya se encuentra agregado.`)
              }
            }

          }
        }

      } else if(response.status === 2) {
        alert('Lo sentimos, este código ya fue facturado.')
      }

    }).catch(() => {
      alert('Error, no pudimos procesar tu solicitud. Verifica tu conexión a internet.')
    })


  }

  makeRenderInsertCode() {

  }





  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }

};

export default withRouter(FacturacionPage)